<app-access-item [avatarUser]="owner()" [hideOverflow]="true">
  <app-access-item-header>
    <span
      >{{ owner().first_name }} {{ owner().last_name }}
      @if (isMe()) {
        (You)
      }
    </span>
  </app-access-item-header>
  <app-access-item-body> {{ owner().email }} </app-access-item-body>
  <app-access-item-cta>
    <button
      appButton
      type="button"
      name="owner-access-toggle"
      location="gallery-owner-access-item"
      color="simple-gray"
      weight="bold"
      height="1"
      spacing="1"
      [hasIcon]="true"
      [disabled]="true"
    >
      <span>Owner</span>
    </button>
  </app-access-item-cta>
</app-access-item>
